import React from 'react';
import ProfileMenu from './ProfileMenu';
import LiveEventsHealthIndicator from './LiveEventsHealthIndicator';
import GlobalSearch from './SmartSearch/GlobalSearch';
import { useLocation } from 'react-router-dom';
import { useGlobalMetadata } from '../utils/providers';
import type { EnrichedRouteInfo } from '../types/metadata';
import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();
  const { data: metadata } = useGlobalMetadata();
  const isAdmin = location.pathname.startsWith('/admin');

  // Get the current route name for breadcrumb
  const pathSegment = location.pathname.split('/')[1] || '';
  const currentRoute = metadata?.routeData?.asList?.find(
    (r: EnrichedRouteInfo) => (r.route_name || r.table_name) === pathSegment
  );
  const currentDashboard = metadata?.dashboardData?.byRoute?.[location.pathname];
  const currentReport = metadata?.reportData?.byRoute?.[location.pathname];
  const workflowParentRoute = currentReport?.category === 'Workflow' && currentReport.primary_table_name
    ? metadata?.routeData?.asList?.find(
        (route: EnrichedRouteInfo) => route.table_name === currentReport.primary_table_name
      )
    : undefined;
  const pageLabel = currentDashboard
    ? currentDashboard.ui_label || currentDashboard.dashboard_key
    : location.pathname === '/audit-log'
    ? 'Audit Log'
    : location.pathname === '/email-records'
    ? 'Email Records'
    : currentRoute
    ? (currentRoute as any).label || currentRoute.route_name || currentRoute.table_name
    : workflowParentRoute
    ? (workflowParentRoute as any).label || workflowParentRoute.route_name || workflowParentRoute.table_name
    : currentReport
    ? currentReport.ui_label || currentReport.report_key
    : isAdmin
    ? 'Admin'
    : pathSegment === 'search'
    ? 'Search'
    : '';

  return (
    <header className="sky-header">
      {/* Breadcrumb */}
      <div className="sky-breadcrumb">
        <span className="sky-bc-item">Skyline</span>
        <span className="sky-bc-sep">&rsaquo;</span>
        <span className="sky-bc-current">{pageLabel}</span>
      </div>

      <div className="sky-header-search">{!isAdmin && <GlobalSearch />}</div>

      {/* Right side */}
      <div className="sky-header-right">
        <LiveEventsHealthIndicator />
        <ProfileMenu />
      </div>
    </header>
  );
};

export default Header;
